import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const provider = params.get("provider");
  const sid = params.get("session_id") || (provider === "paypal" ? params.get("token") : null);
  const [state, setState] = useState("checking"); // checking | paid | pending | error
  const [amount, setAmount] = useState(null);

  useEffect(() => {
    if (!sid) { setState("error"); return; }
    let tries = 0;
    const poll = async () => {
      tries += 1;
      try {
        const { data } = provider === "paypal"
          ? await api.post(`/payments/paypal/capture/${sid}`)
          : await api.get(`/payments/status/${sid}`);
        setAmount(data.amount);
        if (data.payment_status === "paid") { setState("paid"); return; }
        if (["expired", "failed"].includes(data.payment_status)) { setState("error"); return; }
      } catch { /* keep trying */ }
      if (tries >= 8) { setState("pending"); return; }
      setTimeout(poll, 2000);
    };
    poll();
  }, [sid, provider]); // eslint-disable-line

  return (
    <div className="eb-container max-w-lg py-24 text-center">
      <div className="eb-card p-10">
        {state === "checking" && <><Loader2 className="w-12 h-12 text-[#FF5A1F] animate-spin mx-auto mb-4" /><h1 className="font-head text-2xl font-bold">Zahlung wird bestätigt…</h1></>}
        {state === "paid" && <>
          <CheckCircle2 className="w-14 h-14 text-emerald-400 mx-auto mb-4" data-testid="payment-success-icon" />
          <h1 className="font-head text-2xl font-bold">Zahlung erfolgreich!</h1>
          <p className="text-slate-400 mt-2">Deine Buchung wurde bestätigt{amount ? ` (${amount} €)` : ""}. Der Laderaum wurde für dich reserviert.</p>
          <Link to="/dashboard" className="eb-btn-primary mt-6" data-testid="success-dashboard-btn">Zu meinen Buchungen</Link>
        </>}
        {state === "pending" && <><Loader2 className="w-12 h-12 text-amber-400 animate-spin mx-auto mb-4" /><h1 className="font-head text-2xl font-bold">Zahlung wird verarbeitet</h1><p className="text-slate-400 mt-2">Das kann einen Moment dauern. Prüfe später dein Dashboard.</p><Link to="/dashboard" className="eb-btn-outline mt-6">Zum Dashboard</Link></>}
        {state === "error" && <><XCircle className="w-14 h-14 text-red-400 mx-auto mb-4" /><h1 className="font-head text-2xl font-bold">Etwas ist schiefgelaufen</h1><Link to="/dashboard" className="eb-btn-outline mt-6">Zum Dashboard</Link></>}
      </div>
    </div>
  );
}
